// import Vue from 'vue';  
// import VueRouter from 'vue-router';  
import HomeComponent from './components/homeComponent.vue';

import {createRouter,createWebHashHistory} from 'vue-router';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component:HomeComponent
        },
    ]
});
  

export default router;